import { DEFAULT_CLIENT_FEATURES, getCachedClientFeatures } from "./api";

export const CLIENT_PAGE_FEATURE_FIELDS = [
  { key: "overview", label: "Overview" },
  { key: "upload_data", label: "Upload Data" },
  { key: "documents", label: "Documents" },
  { key: "carbon_methodology", label: "Carbon Methodology Review" },
  { key: "iso_evidence_packs", label: "ISO Evidence Packs" },
  { key: "ems_readiness", label: "EMS Readiness" },
  { key: "environmental_context", label: "Environmental Context" },
  { key: "environmental_policy", label: "Environmental Policy" },
  { key: "environmental_aspects", label: "Environmental Aspects" },
  { key: "legal_compliance", label: "Legal Compliance" },
  { key: "ems_governance_policy", label: "EMS Governance Policy" },
  { key: "objectives_targets", label: "Objectives & Targets" },
  { key: "controlled_documents", label: "Controlled Documents" },
  { key: "risk_opportunities", label: "Risk & Opportunities" },
  { key: "training_competence", label: "Training & Competence" },
  { key: "operational_controls", label: "Operational Controls" },
  { key: "actions_deadlines", label: "Actions & Deadlines" },
  { key: "internal_audits", label: "Internal Audits" },
  { key: "ems_audit_trail", label: "EMS Audit Trail" },
  { key: "non_conformance", label: "Non-Conformance" },
  { key: "certification_workflow", label: "Certification Workflow" },
  { key: "management_reviews", label: "Management Reviews" },
  { key: "overview_settings", label: "Overview Settings" },
  { key: "reminders_escalations", label: "Reminders and Escalations" },
];

export const CLIENT_SECTION_LINKS = [
  { to: "/dashboard", label: "Overview", feature: "overview" },
  { to: "/dashboard/upload", label: "Upload Data", feature: "upload_data" },
  { to: "/dashboard/documents", label: "Documents", feature: "documents" },
  { to: "/dashboard/carbon-methodology", label: "Carbon Methodology Review", feature: "carbon_methodology" },
  { to: "/dashboard/sustainability-settings", label: "Overview Settings", feature: "overview_settings" },

  { to: "/dashboard/ems-readiness", label: "EMS Readiness", feature: "ems_readiness" },
      { to: "/dashboard/environmental-context", label: "Environmental Context", feature: "environmental_context" },
  { to: "/dashboard/environmental-policy", label: "Environmental Policy", feature: "environmental_policy" },
  { to: "/dashboard/ems-governance-policy", label: "EMS Governance Policy", feature: "ems_governance_policy" },
  { to: "/dashboard/certification-workflow", label: "Certification Workflow", feature: "certification_workflow" },
  { to: "/dashboard/actions-deadlines", label: "Actions & Deadlines", feature: "actions_deadlines" },
  { to: "/dashboard/ems-reminders", label: "Reminders & Escalations", feature: "reminders_escalations" },
  { to: "/dashboard/ems-audit-trail", label: "EMS Audit Trail", feature: "ems_audit_trail" },
  { to: "/dashboard/iso-evidence-packs", label: "ISO Evidence Packs", feature: "iso_evidence_packs" },

  { to: "/dashboard/environmental-aspects", label: "Environmental Aspects", feature: "environmental_aspects" },
  { to: "/dashboard/legal-compliance", label: "Legal Compliance", feature: "legal_compliance" },
  { to: "/dashboard/objectives-targets", label: "Objectives & Targets", feature: "objectives_targets" },
  { to: "/dashboard/risk-opportunities", label: "Risk & Opportunities", feature: "risk_opportunities" },
  { to: "/dashboard/training-competence", label: "Training & Competence", feature: "training_competence" },
  { to: "/dashboard/internal-audits", label: "Internal Audits", feature: "internal_audits" },
  { to: "/dashboard/non-conformance", label: "Non-Conformance", feature: "non_conformance" },
  { to: "/dashboard/operational-controls", label: "Operational Controls", feature: "operational_controls" },
  { to: "/dashboard/management-reviews", label: "Management Reviews", feature: "management_reviews" },
  { to: "/dashboard/controlled-documents", label: "Controlled Documents", feature: "controlled_documents" },
];

export const CLIENT_NAV_GROUPS = [
  {
    label: "Carbon data & reporting",
    items: [
      { to: "/dashboard/upload", label: "Upload Data", feature: "upload_data" },
      { to: "/dashboard/documents", label: "Documents", feature: "documents" },
      { to: "/dashboard/carbon-methodology", label: "Carbon Methodology Review", feature: "carbon_methodology" },
      { to: "/dashboard/iso-evidence-packs", label: "ISO Evidence Packs", feature: "iso_evidence_packs" },
    ],
  },
  {
    label: "EMS Setup",
    items: [
  { to: "/dashboard/ems-readiness", label: "EMS Readiness", feature: "ems_readiness" },
  { to: "/dashboard/environmental-context", label: "Environmental Context", feature: "environmental_context" },
      { to: "/dashboard/environmental-policy", label: "Environmental Policy", feature: "environmental_policy" },
      { to: "/dashboard/environmental-aspects", label: "Environmental Aspects", feature: "environmental_aspects" },
      { to: "/dashboard/legal-compliance", label: "Legal Compliance", feature: "legal_compliance" },
    ],
  },
  {
    label: "Governance & Policies",
    items: [
      { to: "/dashboard/ems-governance-policy", label: "EMS Governance Policy", feature: "ems_governance_policy" },
      { to: "/dashboard/controlled-documents", label: "Controlled Documents", feature: "controlled_documents" },
    ],
  },
  {
    label: "Risk & Planning",
    items: [
      { to: "/dashboard/objectives-targets", label: "Objectives & Targets", feature: "objectives_targets" },
      { to: "/dashboard/risk-opportunities", label: "Risk & Opportunities", feature: "risk_opportunities" },
      { to: "/dashboard/operational-controls", label: "Operational Controls", feature: "operational_controls" },
      { to: "/dashboard/actions-deadlines", label: "Actions & Deadlines", feature: "actions_deadlines" },
    ],
  },
  {
    label: "Monitoring & Auditing",
    items: [
      { to: "/dashboard/training-competence", label: "Training & Competence", feature: "training_competence" },
      { to: "/dashboard/internal-audits", label: "Internal Audits", feature: "internal_audits" },
      { to: "/dashboard/ems-audit-trail", label: "EMS Audit Trail", feature: "ems_audit_trail" },
      { to: "/dashboard/non-conformance", label: "Non-Conformance", feature: "non_conformance" },
    ],
  },
  {
    label: "Certification",
    items: [
      { to: "/dashboard/certification-workflow", label: "Certification Workflow", feature: "certification_workflow" },
      { to: "/dashboard/management-reviews", label: "Management Reviews", feature: "management_reviews" },
    ],
  },
  {
    label: "Settings",
    items: [
      { to: "/dashboard/sustainability-settings", label: "Overview Settings", feature: "overview_settings" },
      { to: "/dashboard/ems-reminders", label: "Reminders and Escalations", feature: "reminders_escalations" },
    ],
  },
];

export function normalizeClientFeatures(value) {
  const out = { ...DEFAULT_CLIENT_FEATURES };
  const src = value && typeof value === "object" ? value : {};
  Object.keys(out).forEach((k) => {
    if (k in src) out[k] = Boolean(src[k]);
  });
  return out;
}

export function isClientFeatureEnabled(featureKey, features = undefined) {
  if (!featureKey) return true;
  const current = normalizeClientFeatures(features || getCachedClientFeatures());
  return Boolean(current?.[featureKey]);
}

export function getEnabledClientLinks(features = undefined) {
  const current = normalizeClientFeatures(features || getCachedClientFeatures());
  return CLIENT_SECTION_LINKS.filter((link) => isClientFeatureEnabled(link.feature, current));
}

export function getEnabledClientNavGroups(features = undefined) {
  const current = normalizeClientFeatures(features || getCachedClientFeatures());
  return CLIENT_NAV_GROUPS
    .map((group) => ({
      ...group,
      items: group.items.filter((item) => isClientFeatureEnabled(item.feature, current)),
    }))
    .filter((group) => group.items.length > 0);
}

export function getFirstEnabledClientRoute(features = undefined) {
  const enabled = getEnabledClientLinks(features);
  return enabled.length > 0 ? enabled[0].to : "/login";
}
